import { useSelector } from 'react-redux'
import {
  StyleCard,
  StyleColumn,
  StyleLeftWrapper,
  StyleRightWrapper,
  StyleTag,
} from './style'
import Row from '@components/row'
import Typography from '@components/typography'
import Image from '@components/image'
import Column from '@components/column'
import Status from '../../status'
import Button from '@components/button'
import { useNavigate } from 'react-router-dom'
const NextInstantAppointment = () => {
  const navigate = useNavigate()
  const { data: user } = useSelector((state: any) => state.user)
  const { data: appointmentConsultDashboard } = useSelector(
    (state: any) => state.appointmentConsultDashboard,
  )
  const handleClickViewDetails = () => {
    navigate(
      `/${user?.role}/appointments/details-${appointmentConsultDashboard?.nextScheduleAppointment?.id}`,
    )
  }

  return (
    <>
      {!!appointmentConsultDashboard?.nextInstantAppointment?.id ? (
        <StyleColumn>
          <Row alignItems="center" colGap={2}>
            <Typography content="Active Appointment" size={14} />
          </Row>
          <StyleCard>
            <StyleLeftWrapper>
              <Image
                src={`${process.env.BUCKET_URL}/${appointmentConsultDashboard?.nextInstantAppointment?.user?.avatar}`}
                fallbackType="user"
                height={80}
              />
              <Column rowGap={10} justifyContent="center">
                <Typography
                  content={
                    appointmentConsultDashboard?.nextInstantAppointment?.patient
                      ?.name
                  }
                  size={14}
                />
                <Row colGap={10}>
                  <StyleTag>
                    {
                      appointmentConsultDashboard?.nextInstantAppointment
                        ?.patient?.infos?.gender
                    }
                  </StyleTag>
                  <StyleTag>
                    {
                      appointmentConsultDashboard?.nextInstantAppointment
                        ?.patient?.infos?.age
                    }
                  </StyleTag>
                  <StyleTag>
                    {
                      appointmentConsultDashboard?.nextInstantAppointment
                        ?.patient?.infos?.bloodGroup
                    }
                  </StyleTag>
                </Row>
              </Column>
            </StyleLeftWrapper>
            <StyleRightWrapper>
              <Status
                status={
                  appointmentConsultDashboard?.nextInstantAppointment?.status
                }
              />
              <Button
                title="View Details"
                radius={8}
                outline
                height={40}
                onClick={handleClickViewDetails}
              />
              <Button title="Start Call" radius={8} height={40} />
            </StyleRightWrapper>
          </StyleCard>
        </StyleColumn>
      ) : (
        <></>
      )}
    </>
  )
}

export default NextInstantAppointment
